export default __webpack_public_path__ + "static/media/cibn.a22c3104.png";